import React from "react";
import { TFormBuilderItem } from "../../../model/item/formBuilderItem";
import { isFormBuilderButtonItem } from "../../../model/item/formBuilderButton";
import { isFormBuilderCheckboxItem } from "../../../model/item/formBuilderCheckbox";
import { isFormBuilderDateItem } from "../../../model/item/formBuilderDate";
import { isFormBuilderInputItem } from "../../../model/item/formBuilderInput";
import { isFormBuilderSelectItem } from "../../../model/item/formBuilderSelect";
import { isFormBuilderTextItem } from "../../../model/item/formBuilderText";
import { isFormBuilderTextareaItem } from "../../../model/item/formBuilderTextarea";
import { FormBuilderButtonSettings } from "../../settings/button/FormBuilderButtonSettings";
import { FormBuilderInputSettings } from "../../settings/input/FormBuilderInputSettings";
import { FormBuilderSelectSettings } from "../../settings/select/FormBuilderSelectSettings";
import { FormBuilderTextSettings } from "../../settings/text/FormBuilderTextSettings";
import { FormBuilderTextareaSettings } from "../../settings/textarea/FormBuilderTextareaSettings";
import { FormBuilderPanelView } from "../FormBuilderPanelView";
import { useFormBuilderEditorContext } from "../../../formBuilderEditorContext";
import { IFormBuilderItemMetadata } from "../../../hooks/itemMetadataMap/useFormBuilderItemMetadataMap";
import { IFormBuilderRow } from "../../../model/formBuilderRow";
import { FormBuilderCheckboxSettings } from "../../settings/checkbox/FormBuilderCheckboxSettings";
import { FormBuilderDateSettings } from "../../settings/date/FormBuilderDateSettings";

interface IFormBuilderPanelItemViewProps {
  row: IFormBuilderRow;
  item: TFormBuilderItem;
  metadata: IFormBuilderItemMetadata;
}

export function FormBuilderPanelItemView(props: IFormBuilderPanelItemViewProps) {
  const { row, item, metadata } = props;

  const { formBuilderController } = useFormBuilderEditorContext();
  
  function renderContent() {
    if (isFormBuilderButtonItem(item)) {
      return (
        <FormBuilderButtonSettings key={item.key} item={item} />
      );
    }

    if (isFormBuilderCheckboxItem(item)) {
      return (
        <FormBuilderCheckboxSettings key={item.key} item={item} />
      );
    }

    if (isFormBuilderDateItem(item)) {
      return (
        <FormBuilderDateSettings key={item.key} item={item} />
      );
    }

    if (isFormBuilderInputItem(item)) {
      return (
        <FormBuilderInputSettings key={item.key} item={item} />
      );
    }

    if (isFormBuilderSelectItem(item)) {
      return (
        <FormBuilderSelectSettings key={item.key} item={item} />
      );
    }

    if (isFormBuilderTextItem(item)) {
      return (
        <FormBuilderTextSettings key={item.key} item={item} />
      );
    }

    if (isFormBuilderTextareaItem(item)) {
      return (
        <FormBuilderTextareaSettings key={item.key} item={item} />
      );
    }

    // eslint-disable-next-line no-unused-vars
    const _exhaustiveCheck: never = item;
    return null;
  }

  return (
    <FormBuilderPanelView
      header={{
        heading: metadata.label,
        onBack: () => {
          formBuilderController.selectEntity({
            selectedEntity: {
              type: "row",
              key: row.key,
              editingMode: {
                type: "none",
              },
            },
          });
        },
      }}
    >
      {renderContent()}
    </FormBuilderPanelView>
  );
}
